import React from "react";
import { Link } from "gatsby";
import PropTypes from "prop-types";
import sanitizeHtml from "../../utils/sanitizeHtml";
import Image from "../Image/Image";
import classNames from "../../utils/classNames";

// import Img from "../components/Img";
import "@coopdigital/shared-component--editorialcard/dist/editorialCard.css";
import "./editorialcard.css";

const EditorialCard = ({
  title,
  titleClass = "",
  subtitle,
  content,
  link,
  imageData,
  horizontal,
  horizontalOnTablet,
  className,
}) => {
  const classes = classNames("coop-c-editorialcard", [
    horizontal && `coop-c-editorialcard--horizontal`,
    horizontalOnTablet && `coop-c-editorialcard--horizontalOnTablet`,
    className,
  ]);

  return (
    <article className={classes}>
      <Link
        to={link}
        className="coop-c-editorialcard__link"
        data-contenttype="Card|Editorial"
        data-contentparent=""
        data-linktext=""
      >
        <div className="coop-c-editorialcard__inner">
          {imageData && (
            <div className="coop-c-editorialcard__media">
              <Image
                imageSrc={imageData.imageChildSharp.gatsbyImageData}
                altText={imageData.altText}
              />
            </div>
          )}

          <div className="coop-c-editorialcard__content">
            <header className="coop-c-editorialcard__header">
              {subtitle && (
                <p className="coop-c-editorialcard__subtitle">{subtitle}</p>
              )}
              {title && (
                <h3 className={`coop-c-editorialcard__title ${titleClass}`}>
                  <span>{title}</span>
                </h3>
              )}
            </header>
            {content && (
              <div
                className="coop-c-editorialcard__body"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}
              />
            )}
          </div>
        </div>
      </Link>
    </article>
  );
};

EditorialCard.defaultProps = {
  subtitle: null,
  image: null,
};

EditorialCard.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  image: PropTypes.string,
};

export default EditorialCard;
